<template>
  <div class="zero-time-scroll" ref="zeroTimeScroll">
    <ul>
      <!-- <li
        v-if="isShowFalsh && remainTime > 0"
        :class="{
          'time-scorll-item': true,
          'active': timeList.length === timeIndex
        }"
        @click="timeScrollClick(timeList.length)">
        <p>剩余{{remainTime}}分钟</p>
        <p>限时抢购</p>
      </li> -->
      <template v-if="timeList.length > 0">
        <li
          v-if="timeList.length > 0"
          :class="{
            'time-scorll-item': true,
            active: timeList.length === timeIndex,
            'active--warn': timeList.length === timeIndex && type === 'warn'
          }"
          @click="timeScrollClick(timeList.length)"
        >
          <p>热销商品</p>
          <p></p>
        </li>
        <template>
          <li
            :class="{
              'time-scorll-item': true,
              active: timeIndex === index,
              'active--warn': timeIndex === index && type === 'warn'
            }"
            @click="timeScrollClick(index)"
            v-for="(item, index) in timeList"
            :key="index"
          >
            <p>{{ item.GapDay === 1 ? '次日' : '' }}{{ item.Node }}</p>
            <p v-if="index === 0">抢购进行中</p>
            <p v-else>即将开抢</p>
          </li>
        </template>
      </template>
      <template v-else>
        <li class="time-scorll-item skeleton-scroll" v-for="i in 4" :key="i">
          <p></p>
          <p></p>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  name: 'TimeScrroll',
  data() {
    return {
      bsScroll: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bsScroll = new BScroll(this.$refs.zeroTimeScroll, {
        scrollX: true,
        scrollY: false,
        click: true
      })
    })
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    timeList: {
      type: Array,
      require: true,
      default() {
        return []
      }
    },
    timeIndex: {
      type: Number,
      default: 0
    }
    // isShowFalsh: {
    //   type: Boolean,
    //   default: false
    // },
    // remainTime: {
    //   type: Number,
    //   default: 0
    // }
  },
  methods: {
    timeScrollClick(index) {
      this.$emit('timeScrollClick', index)
      this.$nextTick((res) => {
        let screenW = document.body.clientWidth || window.innerWidth
        let currentElem = document.querySelector('.zero-time-scroll .active')
        let elemW = currentElem.clientWidth
        if (index <= 1) this.bsScroll.scrollTo(0, 0, 200)
        if (currentElem.offsetLeft > screenW / 2 && index < this.timeList.length - 2) {
          let scollX = currentElem.offsetLeft - (screenW / 2 - elemW / 2)
          this.bsScroll.scrollTo(-scollX, 0, 200)
        }
        if (index === this.timeList.length - 1) {
          let lastScrollX = currentElem.offsetLeft - screenW + elemW
          this.bsScroll.scrollTo(-lastScrollX, 0, 200)
        }
      })
    }
  }
}
</script>

<style scoped>
.zero-time-scroll {
  position: relative;
  height: 70px;
  margin: 5px 0 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 2px;
  overflow: hidden;
  margin-bottom: 3px;
}
.zero-time-scroll ul {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
}
.time-scorll-item {
  position: relative;
  height: 55px;
  width: 90px;
  box-sizing: border-box;
  flex-shrink: 0;
  text-align: center;
  margin-right: 5px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 8px 0 #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 0.2s ease-in;
  color: #333;
  cursor: pointer;
}
.time-scorll-item::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top: 6px solid transparent;
  transition: all 0.2s ease-in;
  transform: translateX(-50%);
}
.time-scorll-item.active {
  background: #ff0000;
  color: #fff;
}
.time-scorll-item.active::after {
  border-top-color: #ff0000;
}
.time-scorll-item.active--warn {
  background: #f5f580;
  color: #ff0000;
}
.time-scorll-item.active--warn::after {
  border-top-color: #f5f580;
}
.skeleton-scroll > p {
  height: 14px;
  background: #fafafa;
}
.skeleton-scroll > p:first-child {
  width: 50%;
}
.skeleton-scroll > p:last-child {
  width: 70%;
  margin-top: 5px;
}
</style>
